import { FormattedMessage } from "react-intl";

import Button from "@components/buttons/Button";
import useWebinarRegistration from "@hooks/useWebinarRegistration";
import { ArticleContentTypeEnum, ArticleFragment } from "@typing/Generated";

type Props = {
  article: Pick<ArticleFragment, "__typename" | "contentType" | "id" | "webinarCompleted" | "webinarRegistration">;
  journeyId: string | null;
};

const WebinarRegistrationButton = ({ article, journeyId }: Props) => {
  const handleWebinarRegistration = useWebinarRegistration(article, journeyId);

  if (article.contentType !== ArticleContentTypeEnum.WEBINAR || article.webinarCompleted) {
    return null;
  }

  return (
    <Button
      disabled={article.webinarCompleted || !!article.webinarRegistration}
      onClick={() => handleWebinarRegistration(false)}
    >
      <FormattedMessage
        id={article.webinarRegistration ? "pages.explore.events.registered" : "pages.explore.events.register"}
      />
    </Button>
  );
};

export default WebinarRegistrationButton;
